import { useEffect, type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { PORTAL_LOGIN_PATH } from '@/portal/config';
import { isSessionActive, usePortalSession } from '@/portal/stores/portalSessionStore';

interface ProtectedRouteProps {
  children: ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const token = usePortalSession((state) => state.token);
  const issuedAt = usePortalSession((state) => state.issuedAt);
  const endSession = usePortalSession((state) => state.endSession);
  const location = useLocation();

  const active = isSessionActive({ token, issuedAt });

  useEffect(() => {
    if (token && !active) endSession();
  }, [token, active, endSession]);

  if (!active) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`${PORTAL_LOGIN_PATH}?next=${next}`} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
